exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wrapper-action-btn {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: space-evenly;\n      justify-content: space-evenly;\n  width: 100%; }\n  .wrapper-action-btn .btn-action-style {\n    margin-right: 2px;\n    width: inherit !important; }\n    .wrapper-action-btn .btn-action-style:disabled {\n      background-color: #efefef  !important;\n      border: 1.5px solid #e1e1e1  !important;\n      color: #8f8f8f !important;\n      cursor: not-allowed !important; }\n      .wrapper-action-btn .btn-action-style:disabled i {\n        color: #8f8f8f !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/grid-components/btn-cell-renderer/btn-cell-renderer.component.scss
// module id = 1907
// module chunks = 66